import { render, staticRenderFns } from "./AddEditStaff.vue?vue&type=template&id=7fa8a877"
import script from "./AddEditStaff.vue?vue&type=script&lang=js"
export * from "./AddEditStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports